"use client"

import type { ComponentProps } from "react"
import NextLink from "next/link"
import { Link as IntlLink } from "@/i18n/navigation"
import { isMarketingPath } from "@/i18n/routing"

// Drop-in <Link> for shared marketing chrome (navbar, footer, landing).
// Marketing destinations keep the visitor's locale ("/pricing" renders as
// "/es/pricing" when browsing in Spanish); app-zone destinations
// (/dashboard, /auth, ...) are NEVER prefixed — they're cookie-based and a
// prefixed URL there would 404.
// `locale` is narrowed to what both links accept: next/link also allows
// `false` (a Pages Router opt-out), which next-intl's Link does not.
type Props = Omit<ComponentProps<typeof NextLink>, "locale"> & { locale?: string }

export function LocaleLink({ href, ...rest }: Props) {
  const path = typeof href === "string" ? href : (href.pathname ?? "")
  if (isMarketingPath(path)) {
    return <IntlLink href={href as ComponentProps<typeof IntlLink>["href"]} {...rest} />
  }
  return <NextLink href={href} {...rest} />
}
